
import { mapGetters } from 'vuex';

export default {
    name: 'FooterCasa',
    data() {
        return {
            activeSectionId: null
        };
    },
    components: {
        FooterCopyright: () => import('./FooterCopyright'),
        FooterColumn: () => import('./FooterColumn'),
        FooterLogo: () => import('./FooterLogo')
    },
    computed: {
        ...mapGetters({
            globalSettings: 'global/globalSettings',
            footerSettings: 'footer/footerSettings'
        }),
        sortedImages() {
            return [...this.footerSettings?.column_images]?.sort((a, b) => a.order - b.order);
        },
        footerColumns() {
            let firstId = this.footerSettings?.columns[0]?.id || 0;
            // const workingTimeAndPhonesColumn = {
            //     id: firstId + 1,
            //     name: this.$t('workHours'),
            //     items: [
            //         {
            //             id: 1,
            //             name: this.footerSettings?.workingTime?.workingTimeWeekday
            //         },
            //         {
            //             id: 2,
            //             name: this.footerSettings?.workingTime?.workingTimeWeekends
            //         },
            //         {
            //             id: 3,
            //             name: this.globalSettings?.phones?.mainPhoneNumber
            //         },
            //         {
            //             id: 4,
            //             name: this.globalSettings?.phones?.serviceCenterPhoneNumber
            //         },
            //         {
            //             id: 5,
            //             name: this.globalSettings?.phones?.stationaryPhoneNumber
            //         },
            //         {
            //             id: 6,
            //             name: this.globalSettings?.phones?.supportPhoneNumber
            //         }
            //     ]
            // };

            const addressAndContactsColumn = {
                id: firstId + 2,
                name: this.$t('contacts'),
                items: [
                    {
                        id: 1,
                        name: this.footerSettings?.issuanceOfOnlineOrders
                    },
                    {
                        id: 2,
                        name: this.footerSettings?.workingTime?.workingTimeWeekday,
                        workingTime: [
                            this.footerSettings?.workingTime?.workingTimeWeekday,
                            this.footerSettings?.workingTime?.workingTimeWeekends
                        ]
                    },
                    // {
                    //     id: 3,
                    //     name: this.footerSettings?.workingTime?.workingTimeWeekends
                    // },
                    {
                        id: 3,
                        name: this.globalSettings?.phones?.mainPhoneNumber
                    }
                ]
            };

            const array = [addressAndContactsColumn];

            if (!this.footerSettings?.columns || this.footerSettings.columns.length <= 1) {
                return [...(this.footerSettings?.columns || []), ...array];
            }

            return this.footerSettings?.columns.reduce((acc, item, index) => {
                if (index === 1) {
                    acc.push(addressAndContactsColumn);
                }
                acc.push({
                    ...item,
                    id: index === 0 ? item.id : item.id + array.length
                });
                return acc;
            }, []);
        }
    },
    methods: {
        toggleSection(sectionId) {
            this.activeSectionId = this.activeSectionId === sectionId ? null : sectionId;
        }
    }
};
